module.exports = __webpack_public_path__ + "static/media/backward.d23b1784.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/routes/components/calendar/backward.svg
// module id = 467
// module chunks = 0